import { FeatureSet, stateFeatureSet } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
import { derived } from 'svelte/store';
const allSections = [
    {
        name: Verbiage.my_bets,
        icon: 'MyBetsIcon',
        sidebarOrder: 1,
        href: '/sports/bets'
    },
    {
        name: Verbiage.live,
        icon: 'LiveIcon',
        sidebarOrder: 2,
        href: '/sports/live'
    },
    {
        name: Verbiage.schedule,
        icon: 'ScheduleIcon',
        sidebarOrder: 3,
        href: '/sports/event-builder/?selectedSports=soccer-1&selectedRange=2'
    },
    {
        name: Verbiage.favorites,
        icon: 'FavoritesIcon',
        sidebarOrder: 4,
        href: '/sports/favorites',
        authed: true
    },
    {
        name: Verbiage.football,
        icon: 'FootballIcon',
        sidebarOrder: 5,
        href: '/sports/soccer-1'
    },
    {
        name: Verbiage.basketball,
        icon: 'BasketballIcon',
        sidebarOrder: 6,
        href: '/sports/basketball-2'
    },
    {
        name: Verbiage.baseball,
        icon: 'BaseballIcon',
        sidebarOrder: 7,
        href: '/sports/baseball-3'
    },
    {
        name: Verbiage.tennis,
        icon: 'TennisIcon',
        sidebarOrder: 8,
        href: '/sports/tennis-5'
    },
    {
        name: Verbiage.boxing,
        icon: 'BoxingIcon',
        sidebarOrder: 9,
        href: '/sports/boxing-10'
    },
    {
        name: Verbiage.mma,
        icon: 'MmaIcon',
        sidebarOrder: 10,
        href: '/sports/mixed-martial-arts-117'
    },
    {
        name: Verbiage.table_tennis,
        icon: 'TableTennisIcon',
        sidebarOrder: 11,
        href: '/sports/table-tennis-20'
    },
    {
        name: Verbiage.american_football,
        icon: 'AmericanFootballIcon',
        sidebarOrder: 12,
        href: '/sports/american-football-16'
    },
    {
        name: Verbiage.handball,
        icon: 'HandballIcon',
        sidebarOrder: 13,
        href: '/sports/handball-6'
    },
    {
        name: Verbiage.voleyball,
        icon: 'VolleyballIcon',
        sidebarOrder: 14,
        href: '/sports/volleyball-23'
    },
    {
        name: Verbiage.darts,
        icon: 'DartsIcon',
        sidebarOrder: 15,
        href: '/sports/darts-22'
    },
    {
        name: Verbiage.futsal,
        icon: 'FutsalIcon',
        sidebarOrder: 16,
        href: '/sports/futsal-29'
    },
    {
        name: Verbiage.ehorse_racing,
        icon: 'EhorseRacingIcon',
        sidebarOrder: 17,
        href: '/sports/ehorse-racing-315'
    },
    {
        name: Verbiage.ice_hockey,
        icon: 'IceHockeyIcon',
        sidebarOrder: 18,
        href: '/sports/ice-hockey-4'
    },
    {
        name: Verbiage.f1,
        icon: 'F1Icon',
        sidebarOrder: 19,
        href: '/sports/formula-1-40'
    },
    {
        name: Verbiage.golf,
        icon: 'GolfIcon',
        sidebarOrder: 20,
        href: '/sports/golf-9'
    },
    {
        name: Verbiage.cycling,
        icon: 'CyclingIcon',
        sidebarOrder: 21,
        href: '/sports/cycling-17'
    },
    {
        name: Verbiage.snooker,
        icon: 'SnookerIcon',
        sidebarOrder: 22,
        href: '/sports/snooker-19'
    },
    {
        name: Verbiage.rugby,
        icon: 'RugbyIcon',
        sidebarOrder: 23,
        href: '/sports/rugby-union-12'
    },
    {
        name: Verbiage.fifa,
        icon: 'FifaIcon',
        sidebarOrder: 24,
        href: '/sports/fifa-300'
    },
    {
        name: Verbiage.counter_strike,
        icon: 'CounterStrikeIcon',
        sidebarOrder: 25,
        href: '/sports/counter-strike-109'
    },
    {
        name: Verbiage.league_of_legends,
        icon: 'LoLIcon',
        sidebarOrder: 26,
        href: '/sports/league-of-legends-110'
    },
    {
        name: Verbiage.aussie_rules,
        icon: 'AussieRulesIcon',
        sidebarOrder: 27,
        href: '/sports/australian-football-13'
    },
    {
        name: Verbiage.cricket,
        icon: 'CricketIcon',
        sidebarOrder: 28,
        href: '/sports/cricket-21'
    },
    {
        name: Verbiage.water_polo,
        icon: 'WaterpoloIcon',
        sidebarOrder: 29,
        href: '/sports/water-polo-26'
    },
    {
        name: Verbiage.squash,
        icon: 'SquashIcon',
        sidebarOrder: 30,
        href: '/sports/squash-37'
    },
    {
        name: Verbiage.dota,
        icon: 'DotaIcon',
        sidebarOrder: 31,
        href: '/sports/dota-2-111'
    },
    {
        name: Verbiage.racing,
        icon: 'RacingIcon',
        sidebarOrder: 32,
        href: '/sports/motorcycle-racing-190'
    },
    {
        name: Verbiage.efighting,
        icon: 'EfightingIcon',
        sidebarOrder: 33,
        href: '/sports/efighting-304'
    },
    {
        name: Verbiage.e_cricket,
        icon: 'eCricketIcon',
        sidebarOrder: 34,
        href: '/sports/ecricket-305'
    }
];
export const sections = derived(stateFeatureSet, ($featureSet) => {
    return allSections.filter((section) => !section.rel || section.rel !== FeatureSet.Release || $featureSet !== FeatureSet.Release);
});
